import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import ReactPlayer from 'react-player';
import './ImageCarousel.css';

export default function ImageCarousel(props) {
    if (!props.imageList || props.imageList.length === 0)
        return null;
    return <div className="image-container">
        <Carousel ref={props.carouselRef} showStatus={false} showThumbs={false} autoPlay={true} infiniteLoop={true} centerMode={true} centerSlidePercentage={102}>
            {props.imageList.map((d, ix) =>
                d.startsWith("youtube:") ?
                    <ReactPlayer height="100%" width="100%" key={ix} url={d.slice(8)} playing={false} className='react-player' />
                    :
                    <img src={d[0]==="." ? d : `./data/${d}`} key={ix} alt="📷"/>
            )}                        
        </Carousel>
    </div>;
}